import { Box, Text } from "@shared/primitive-components"
import { fleetSafetyThreshold as threshold } from "../../const"
import { severityLabelStyles as styles } from "../../styles"

export const SEVERITY_LABEL_TEST_IDS = {
  LABEL: `severity_trip_score_label`,
}

export type SeverityLabelProps = {
  score: number | null
}

const getLabel = (score: number | null) => {
  if (typeof score !== `number`) return `Risk level`
  if (score >= threshold.low) return `Low risk`
  if (score >= threshold.medium) return `Medium risk`
  if (score >= threshold.high) return `High risk`
  if (score >= threshold.severe) return `Severe risk`
  return ``
}

export const SeverityLabel = ({ score }: SeverityLabelProps) => (
  <>
    <Box css={styles.label(score)}>
      <Text use="headline2" css={styles.text} data-testid={SEVERITY_LABEL_TEST_IDS?.LABEL}>
        {getLabel(score)}
      </Text>
    </Box>
  </>
)
